export default {"src":"/_next/static/media/location-icon.ad502bad.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};